import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import correspondenceLetterIcon from './../../../assets/img/mm/envelope-solid-full.svg';
import download from 'downloadjs';
import ReactTable from 'react-table';
import { Modal } from 'react-bootstrap';

class CorrespondenceLetterLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: getLoginDistrictInfo(),
            letterLogsList: {
                letterLog: [],
                nonResponseQueue: []
            },
            showApplicationModal: false,
            loading: false
        };
    }

    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    };

    // Close modal
    closeApplicationModal = () => {
        this.setState({
            showApplicationModal: false
        });
    };

    // Letter Log columns
    getLetterLogColumns = () => [
        {
            Header: 'Application ID',
            accessor: 'applicationId',
            width: 130,
            style: { textAlign: 'center' }
        },
        {
            Header: 'Verify Id',
            accessor: 'verifyId',
            width: 130,
            style: { textAlign: 'center' }
        },
        {
            Header: 'Type',
            accessor: 'communicationType',
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span
                    className="label label-primary"
                    style={{ borderRadius: '999px' }}
                >
                    {value || '-'}
                </span>
            )
        },
        {
            Header: 'Channel',
            accessor: 'channel',
            width: 110,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span
                    className="label label-success"
                    style={{ borderRadius: '999px' }}
                >
                    {value || '-'}
                </span>
            )
        },
        {
            Header: 'Sent Date',
            accessor: 'sentDate',
            width: 150,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                value && moment(value).isValid()
                    ? moment(value).format('YYYY-MM-DD')
                    : '-'
            )
        },
        {
            Header: 'Recipient',
            accessor: 'recipientEmail',
            style: { textAlign: 'center' },
            width: 250,
            Cell: ({ value }) => value || '-'
        },
        {
            Header: 'Document Sent',
            accessor: 'documentAvailable',
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                value === true ? (
                    <span
                        className="label label-success"
                        style={{ borderRadius: '999px' }}
                    >
                        true
                    </span>
                ) : (
                    <span
                        className="label label-danger"
                        style={{ borderRadius: '999px' }}
                    >
                        false
                    </span>
                )
            )
        }
    ];

    // Non-response queue columns
    getNonResponseColumns = () => [
        {
            Header: 'Application ID',
            accessor: 'applicationId',
            width: 150,
            style: { textAlign: 'center' }
        },
        {
            Header: 'Verify ID',
            accessor: 'verifyId',
            width: 120,
            style: { textAlign: 'center' }
        },
        {
            Header: 'Guardian Name',
            accessor: 'guardianName',
            style: { textAlign: 'center' },
            width: 200
        },
        {
            Header: 'Student Name(s)',
            accessor: 'studentNames',
            style: { textAlign: 'center' },
            width: 200
        },
        {
            Header: 'Workflow Stage',
            accessor: 'workflowStage',
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span
                    className="label label-warning"
                    style={{ borderRadius: '999px' }}
                >
                    {value || '-'}
                </span>
            )
        },
        {
            Header: 'Response Status',
            accessor: 'responseStatus',
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span
                    className="label label-warning"
                    style={{ borderRadius: '999px' }}
                >
                    {value || '-'}
                </span>
            )
        },
        {
            Header: 'Appeal Filed',
            accessor: 'appealFiled',
            width: 150,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                value === true ? (
                    <span 
                        className="label label-success"
                        style={{ borderRadius: '999px' }}
                    >
                        true
                    </span>
                ) : (
                    <span
                        className="label label-danger"
                        style={{ borderRadius: '999px' }}
                    >
                        false
                    </span>
                )
            )
        }
    ];

    // Get report data
    getLetterLogReport = () => {
        const districtID = this.state.userInfo.districtId;
        const verificationYear = this.props.selectedSchoolYear;
        const schoolId = this.props.selectedSchoolId;
        this.setState({ loading: true });
        const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';
        get(
            `/verification/reports/letterLogAndNonResponse/${districtID}/${verificationYear}?${schoolParam}access_token=`
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(data => {
                this.setState({
                    letterLogsList: {
                        letterLog: data.letterLog || [],
                        nonResponseQueue: data.nonResponseQueue || []
                    },
                    showApplicationModal: true,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    letterLogsList: {
                        letterLog: [],
                        nonResponseQueue: []
                    }
                });
                _addNotificationError( error.message || 'No data found.', this.props);
                console.log('Get Letter Log Report response:',   error );
            });
       };

    // Export complete report PDF
    downloadLetterLog = () => {
        const districtID = this.state.userInfo.districtId;
        const verificationYear = this.props.selectedSchoolYear;
        const schoolId = this.props.selectedSchoolId;
        this.setState({ loading: true });
        const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';
        get(
            `/verification/reports/letterLogAndNonResponse/export/${districtID}/${verificationYear}?${schoolParam}format=pdf&access_token=`
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.blob();
            })
            .then((blob) => {
                download(
                    blob,
                    `LetterLogAndNonResponse_${verificationYear}.pdf`,
                    'application/pdf'
                );
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ loading: false });
                _addNotificationError( error.message || 'No data found.', this.props);
                console.error(  'Error downloading Letter Log PDF:', error);
            });
    };

    render() {
        const { letterLogsList, showApplicationModal, loading  } = this.state;
        return (
            <Fragment>
                {/* Report Card */}    
                 <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                             <div className="reportCard-widget-title-wrapper">
                                 <div className="reportCard-widget-date-primary">
                                     <img src={correspondenceLetterIcon} style={{ width: '40px', height: '40px' }} />
                                 </div>
                                 <div className="reportCard-widget-meeting-info">
                                     <span className="reportCard-widget-pro-title color-3"><b>Correspondence & Letter Log Report</b></span>
                                     <p>Append-only send history</p>
                                 </div>
                             </div>
                            
                                <div className='reportCard-widget-meeting-action' style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                     <button type='button' className="btn btn-success btn-sm" 
                                     disabled={loading}
                                     style={{ margin: '0px' }} onClick={() => {
                                        this.getLetterLogReport()
                                    }}> <i className="fa fa-folder-open-o" /> {''}Open</button>
                               
                            </div>
                        </div>
                    </div>
                </div> 
                {/* Modal */}
                <Modal
                    show={showApplicationModal}
                    onHide={this.closeApplicationModal}
                    bsSize="lg"
                    dialogClassName="verification-details-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                           <b> Correspondence & Letter Log </b>   
                            <button style={{ marginLeft: '65%' }}
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={this.downloadLetterLog}
                                disabled={loading}
                            >
                                <i className="fa fa-file-pdf-o" />
                                {' '}Export PDF
                            </button>
                        </Modal.Title>                      
                        {/* <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginBottom: '15px'
                            }}
                        >

                            <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={this.downloadLetterLog}
                                disabled={loading}
                            >
                                <i className="fa fa-file-pdf-o" />
                                {' '}Export PDF
                            </button>
                        </div> */}
                    </Modal.Header>
                    <Modal.Body>
                        {/* ========================= */}
                        {/* LETTER LOG TABLE */}
                        {/* ========================= */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '10px'
                            }}
                        >
                            <h4 style={{ margin: 0 }}>
                                Letter Log
                            </h4>
                            <span
                                className="label label-primary"
                                style={{
                                    borderRadius: '999px'
                                }}
                            >
                                {letterLogsList.letterLog.length} Records
                            </span>
                        </div>
                        <ReactTable
                            data={letterLogsList.letterLog}
                            columns={this.getLetterLogColumns()}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10, 20]}
                            showPagination={true}
                            sortable={false}
                            filterable={false}
                            minRows={0}
                            className="-striped -highlight"
                            noDataText="No letter log records found"
                        />
                        {/* ========================= */}
                        {/* NON RESPONSE TABLE */}
                        {/* ========================= */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '30px',
                                marginBottom: '10px'
                            }}
                        >
                            <h4 style={{ margin: 0 }}>
                                Non-Response Queue
                            </h4>
                            <span
                                className="label label-warning"
                                style={{
                                    borderRadius: '999px'
                                }}
                            >
                                {letterLogsList.nonResponseQueue.length} Records
                            </span>
                        </div>
                        <ReactTable
                            data={letterLogsList.nonResponseQueue}
                            columns={this.getNonResponseColumns()}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10, 20]}
                            showPagination={true}
                            sortable={false}
                            filterable={false}
                            minRows={0}
                            className="-striped -highlight"
                            noDataText="No non-response records found"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={this.closeApplicationModal}
                        >   Close
                        </button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}
export default CorrespondenceLetterLog;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/correspondenceLetterLog.js